import PropTypes from "prop-types";
import styles from "./styles.module.css";
const InfoCard = ({ icon, title, children }) => {
  return (
    <div className={styles["info-card"]}>
      <div className={styles["info-card__header"]}>
        <img src={icon} alt="icon" className={styles["info-card__icon"]} />
        <div className={styles["info-card__title"]}>{title}</div>
      </div>
      <div className={styles["info-card__content"]}>{children}</div>
    </div>
  );
};

InfoCard.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default InfoCard;
